import React, { Component } from 'react'

// Elements
import Grid from '../grid'

// Styles
import './tableHeader.scss'

class TableHeader extends Component {
  getVariantStyle () {
    const { simple } = this.props

    if (simple) {
      return ' table-header--simple'
    }

    return ' table-header'
  }

  getStyle () {
    let classNames = this.getVariantStyle()

    if (this.props.expand) {
      classNames += ' table-header--expand'
    }
    if (this.props.className) {
      classNames += ` ${this.props.className}`
    }

    return classNames
  }

  render () {
    const { cols, children } = this.props

    return (
      <Grid
        cols={cols}
        className={'element-table-header' + this.getStyle()}
      >
        {children}
      </Grid>
    )
  }
}

TableHeader.displayName = 'TableHeader'

TableHeader.defaultProps = {
  simple: false,
  cols: [],
  expand: false
}

export default TableHeader



// WEBPACK FOOTER //
// ./src/app/shared/elements/tableHeader/index.js